import script from "./CanvasTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./CanvasTemplate.vue?vue&type=script&setup=true&lang=js"

import "./CanvasTemplate.vue?vue&type=style&index=0&id=a5eaec2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5eaec2e"]])

export default __exports__